import Header from './Header';
import Hero from './Hero';
import Marquee from './Marquee';
import ValueProps from './ValueProps';
import Story from './Story';
import Categories from './Categories';
import ShanverB2B from './ShanverB2B';
import Manifesto from './Manifesto';
import Process from './Process';
import FAQ from './FAQ';
import Certificates from './Certificates';
import ContactForm from './ContactForm';
import Footer from './Footer';
import { Toaster } from 'sonner';

export default function HorecaLanding() {
  return (
    <div className="min-h-screen paper-cream text-[#1F1F1F] font-body">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ValueProps />
        <Story />
        <Manifesto />
        <Categories />
        <ShanverB2B />
        <Process />
        <Certificates />
        <FAQ />
        <ContactForm />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{ style: { fontFamily: "'DM Sans', sans-serif" } }}
      />
    </div>
  );
}
